import { FaWallet, FaCoins, FaMoneyBillWave } from "react-icons/fa";
import { useGetBalanceQuery } from "../../services/userApi";
import Loader from "../Loader";
import "./BalanceComponent.css";

const BalanceComponent = () => {
  const { data: balanceData, isLoading, error } = useGetBalanceQuery();

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: '2rem' }}>
        <Loader size={40} />
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: '1rem', textAlign: 'center', color: '#999' }}>
        Bakiye bilgileri yüklenirken bir hata oluştu.
      </div>
    );
  }

  const balance = balanceData || {
    cekilebilir_bakiye: 0.00,
    site_kredisi: 0.00,
    toplam_cekilen: 0.00
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('tr-TR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  };

  return (
    <div className="balance-container">
      <div className="balance-grid">
        <div className="balance-card">
          <div className="balance-icon">
            <FaWallet />
          </div>
          <div className="balance-content">
            <h4>Çekilebilir Bakiye</h4>
            <p className="balance-amount">₺{formatCurrency(balance.cekilebilir_bakiye)}</p>
            <span className="balance-description">Banka hesabınıza çekebilirsiniz</span>
          </div>
        </div>

        <div className="balance-card">
          <div className="balance-icon">
            <FaCoins />
          </div>
          <div className="balance-content">
            <h4>BiPuan</h4>
            <p className="balance-amount">₺{formatCurrency(balance.site_kredisi)}</p>
            <span className="balance-description">Sadece site içinde kullanılabilir</span>
          </div>
        </div>

        <div className="balance-card">
          <div className="balance-icon">
            <FaMoneyBillWave />
          </div>
          <div className="balance-content">
            <h4>Toplam Çekilen</h4>
            <p className="balance-amount">₺{formatCurrency(balance.toplam_cekilen)}</p>
            <span className="balance-description">Şimdiye kadar çekilen tutar</span>
          </div>
        </div>
      </div>

      <div className="balance-actions">
        {/* <button className="btn-withdraw" disabled={balance.cekilebilir_bakiye <= 0}>
          <FaMoneyBillWave /> Bakiye Çek
        </button> */}
        <button className="btn-history">
          İşlem Geçmişi
        </button>
      </div>
    </div>
  );
};

export default BalanceComponent;
